import * as React from 'react';
import { Box } from '@mui/material';
import { useButtonOverlayContext } from 'app-context';

import { useComponent } from 'hooks/useComponent';
import { Button, Text } from 'ui';
import palette from 'ui/theme/palette';

export const ButtonOverlay: React.FC = useComponent(() => {
  const [buttonOverlayState] = useButtonOverlayContext();
  const { isShowing, isLoading, buttonTitle, buttonAction, cancelAction, displayText, hideSaveButton } = {
    ...buttonOverlayState
  };

  return (
    <Box
      sx={{
        display: isShowing ? 'flex' : 'none',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '78px',
        backgroundColor: '#3A3C45',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        opacity: '80%',
        zIndex: 1001
      }}
    >
      {displayText && (
        <Box sx={{ margin: 'auto 0.5rem' }}>
          <Text content={displayText} sx={{ color: palette.primary.contrastText }} />
        </Box>
      )}
      {cancelAction && (
        <Button width="96px" label="Cancel" onClick={cancelAction} color={'default'} isLoading={isLoading} />
      )}
      {!hideSaveButton && !isLoading && (
        <Box sx={{ margin: '0 0 0 0.25rem' }}>
          <Button
            useMinWidth
            label={buttonTitle ?? 'Save'}
            onClick={() => {
              if (buttonAction) {
                buttonAction();
              }
            }}
            color={'primary'}
          />
        </Box>
      )}
    </Box>
  );
});
